import _ from "lodash"
import saveAs from 'file-saver'
import XLSX from "xlsx"

function s2ab(s) {
	var buf = new ArrayBuffer(s.length);
	var view = new Uint8Array(buf);
	for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
	return buf;
}

export default {
	methods: {
		saveAsXLSX($el, filename) {
			return new Promise((resolve) => {
				this.$nextTick(() => {
					let wb = { SheetNames: [], Sheets: {} }
					let ws = XLSX.utils.table_to_sheet($el, { raw: true })
					let fname = "全部"
					wb.SheetNames.push(fname)
					wb.Sheets[fname] = ws
					let result = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: 'binary' })
					let blob = new Blob([s2ab(result)], { type: "application/octet-stream" })
					saveAs(blob, filename)
					resolve()
				})
			})
		},
	},
}